






















































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import NotificationCenter from './NotificationCenter/NotificationCenter.vue'
import InboxIcon from './Navbar/InboxIcon.vue'
import { Member } from '../../../types/Member.type'
import { Club } from '@/types/Club.type'
import { BusinessCenter } from '@/types/BusinessCenter.type'
import RouteName from '@/utils/RouteName'

const User = namespace('user')

@Component({
    name: 'DisabledHeader',
    components: {
        NotificationCenter,
        InboxIcon,
    },
})
export default class DisabledHeader extends Vue {
    @Prop({ type: String, default: '' }) afterLoginRedirect!: string

    @User.State me!: Member
    @User.Getter('isAdmin') isAdmin!: boolean

    RouteName: typeof RouteName = RouteName

    ffMemberNeededMsg = `You must be a Frenchfounders member to access this section.`

    get isConnectedAsAdmin() {
        if (this.$store.state.user.decodedToken && this.$store.state.user.decodedToken.roles) {
            return this.$store.state.user.decodedToken.roles
        }

        return false
    }

    get isOnSwitchToMode() {
        return window.__isJwtSwitch
    }

    get clubs(): Array<{ url: string; name: string; id: number }> {
        return (this.$store.state.app.configuration?.forms?.clubs || [])
            .filter((club: Club) => club.slug !== 'beta')
            .map((club: Club) => ({
                id: club.id,
                name: club.name,
                url: `/clubs/${club.slug || club.name.toLocaleLowerCase().split(' ')[0]}/join`,
            }))
    }

    get hubs(): Array<{ url: string; name: string; id: number }> {
        return (this.$store.state.app.configuration?.forms?.hubs || []).map((businessCenter: BusinessCenter) => ({
            id: businessCenter.id,
            name: businessCenter.name,
            url: `/hubs/${businessCenter.slug}`,
        }))
    }
}
